import { useEffect, useState } from "react";

const QUERY = "(max-width: 768px)";

export function useIsMobile() {
  const [mobile, setMobile] = useState(() => window.matchMedia(QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = (e) => setMobile(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return mobile;
}

export const EASE = [0.16, 1, 0.3, 1];

// Framer `viewport`/`transition` presets: phones pre-trigger 150px early and resolve in ~0.5s.
export function reveal(mobile, { duration = 1.0, delay = 0 } = {}) {
  return mobile
    ? {
        viewport: { once: true, margin: "0px 0px 150px 0px", amount: 0.05 },
        transition: { duration: 0.5, delay: 0, ease: EASE },
      }
    : {
        // Desktop: begin as the element clears the fold (-2%) and resolve in ~0.8s (the site's reveal standard).
        viewport: { once: true, margin: "-2%", amount: 0.05 },
        transition: { duration: Math.max(0.5, duration - 0.2), delay, ease: EASE },
      };
}
